// extracted by mini-css-extract-plugin
export var badge = "_sg-4";
export var selected = "_sg-1";
export var selectedOverlay = "_sg-5";
export var thumbnailButton = "_sg-0";
export var thumbnailFallback = "_sg-3";
export var thumbnailImage = "_sg-2";